import React, { useState } from 'react'
import Cabin from '../components/LocationDetails/Cabin'
import Booking from '../components/LocationDetails/Booking'
import Surroundings from '../components/LocationDetails/Surroundings'
import TheAmenities from '../components/LocationDetails/TheAmenities'
import LocationInfo from '../components/LocationDetails/LocationInfo'
import GrandOpening from '../components/Shared/GrandOpening'
import ImageSlider from '../components/Shared/ImageSlider'
import TheCalendar from '../components/TheCalendar'
import Calendar from 'react-calendar'
import { useNavigate } from 'react-router-dom'
import { formatDate } from '../utils/formatDate'

const LocationDetails = () => {
  const [checkAvailability, setCheckAvailability] = useState(false);
  const [value, setValue] = useState(null);

  const navigate = useNavigate();

  const tileContent = ({ date, view }) => {
    if (view === 'month' && value && value.length === 2) {
      const [start, end] = value;
      if (date >= start && date <= end) {
        return <div className="text-sm text-white">$99</div>;
      }
    }
    return null;
  };

  const handleBookNow = () => {
    setCheckAvailability(false);

    if (value && value.length === 2) {
      const [start, end] = value;
      const startDate = start.toISOString().split("T")[0];
      const endDate = end.toISOString().split("T")[0];
      navigate(`/checkout?start=${startDate}&end=${endDate}`);
    }
  };

  return (
    <div className='bg-[#fafafa]'>
      <ImageSlider />
      <div className='flex'>
        <div className='w-full lg:w-2/3 px-4 lg:px-6'>
          <LocationInfo />
          <GrandOpening />
          <Surroundings />
          <TheAmenities />
          <Cabin />
          <Booking />
        </div>
        <div className='hidden lg:block w-1/3 mx-8'>
          <TheCalendar
            value={value}
            setValue={setValue}
            tileContent={tileContent}
          />
        </div>
        {/* Change from fixed to sticky on mobile to prevent scroll jumping */}
        <div className='lg:hidden flex w-full sticky bottom-0 bg-white px-4 py-1 z-20'>
          {
            checkAvailability ?
              <div classname="flex flex-col">
                {/* <Calendar 
                  onChange={setValue}
                  value={value}
                  minDate={new Date()}
                  selectRange={true}
                  className="mt-6 border-none"
                  tileContent={tileContent}
                /> */}
                <Calendar
                  onChange={setValue}
                  value={value}
                  minDate={new Date(2025, 3, 3)} // Blocks selection until April 2nd, 2025
                  selectRange={true}
                  className="mt-6 border-none"
                  tileContent={tileContent}
                />

                <div className='w-full flex items-center justify-between'>
                  <p className='font-normal text-[16px] text-[#7a7a7a]'>{value ? <span><b className='text-[24px] text-black'>$99</b> PER NIGHT</span> : 'Add dates for prices'}</p>
                  <button className='text-white bg-black rounded-md my-4 text-[16px] font-medium p-3.5 px-6' onClick={() => setCheckAvailability(false)}>{value ? 'Save' : 'Cancel'}</button>
                </div>
              </div>
              :
              <div className='w-full flex items-center justify-between'>
                <p className='font-normal text-[16px] text-[#7a7a7a]'>{value ? <div className='flex flex-col space-y-1'><span><b className='text-[24px] text-black'>$99</b> PER NIGHT</span> <span className='text-[14px] text-black underline'>{formatDate(value)}</span></div> : 'Add dates for prices'}</p>
                {
                  value ?
                    <button className='text-white bg-black rounded-md my-4 text-[16px] font-medium p-3.5 px-6' onClick={handleBookNow}>Reserve</button>
                    :
                    <button className='disabled:bg-gray-300 border text-black border-black rounded-md my-4 text-[16px] font-medium p-3.5' onClick={() => setCheckAvailability(true)}>Check Availability</button>
                }
              </div>
          }
        </div>
      </div>
    </div>
  )
}

export default LocationDetails